<template>
  <div :style="{'background-color':background_color}">
    <div class="container">
      <div class="text-center m-4">
        <img width="150px" :src="logo_url" alt="logo">
      </div>
      <h2 class="text-white text-center m-4">{{ app_name }}</h2>
      <h2 class="text-white text-center m-4">Pontos de Venda</h2>
      <div class="row m-2">
        <div class="div-terms">
          <vue-map id="map" :centerOv="center" :markerList="markersList" v-if="markers.length > 0">
          </vue-map>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueMap from '../components/VueMap'
import axios from 'axios';

export default {
  components: {VueMap},
  data: function () {
    return {
      markers: [],
      size: 200,
    }
  },
  mounted() {
    axios.get('/api/pos/all', {params: {status: 4}}).then(res => {
      var pdvs = res.data.data;
      if (pdvs) {
        pdvs.forEach(pdv => {
          if (pdv.latitude !== null && pdv.longitude !== null) {
            this.markers.push({
              url: require('@/assets/imgs/estar-mini-2.png'),
              infoText: '<div id="content">' +
                  '<div id="siteNotice">' +
                  '</div>' +
                  '<h1 id="firstHeading" class="firstHeading">' + pdv.fancy_name + '</h1>' +
                  '<div id="bodyContent">' +
                  '<p>' + pdv.address.street + ', ' + pdv.address.number + ' - ' + pdv.address.neighborhood + ' - ' + pdv.address.city + ' - ' + pdv.address.state + '</p>' +
                  '<p><a class="btn btn-white btn-animation-1 center-align" href="https://www.google.com/maps?saddr=My+Location&daddr=' + pdv.latitude + ',' + pdv.longitude + '" target="_blank">' +
                  'Como chegar?</a></p>' +
                  '</div>' +
                  '</div>',
              position: {
                lat: Number(pdv.latitude),
                lng: Number(pdv.longitude)
              }
            })
          }
        });
      }
    });
  },
  computed: {
    app_name: function () {
        return process.env.VUE_APP_NAME;
    },
    logo_url: function () {
      return require('@/assets/imgs/logos/' + process.env.VUE_APP_LOGO_NAME);
    },
    background_color: function () {
      return process.env.VUE_APP_COLOR;
    },
    markersList: function () {
      return this.markers;
    },
    center: function (){
      return {
        lat: parseFloat(process.env.VUE_APP_DEFAULT_LAT),
        lng: parseFloat(process.env.VUE_APP_DEFAULT_LNG),
      };
    },
  }
}
</script>
<style scoped>
.div-terms {
  background: white;
  padding: 15px;
  border-radius: 15px;
  width: 100%;
}

.div-estar {
  background-color: white;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  border-radius: 200px;
}

.logo-estar {
  height: 75px;
  margin: 13px auto;
  display: table;
}

.bg-qr-code {
  background-color: #003A73 !important;
}

i {
  color: #ffffff;
  font-size: 100px;
}

h2 {
  font-size: 34px;
  color: #ffffff;
  font-family: Roboto-Black;
}

h5 {
  font-family: Roboto-Black;
  font-size: 24px;
  color: #58595B;
}

p {
  font-size: 14px;
  color: #ffffff;
  font-family: Roboto-Regular;
  margin: 0;
}

@media only screen and (max-width: 768px) {
  * {
    text-align: center !important;
  }

  p {
    margin-top: 20px;
    margin-bottom: 5px;
  }
}

.btn:link,
.btn:visited {
  text-decoration: none;
  text-transform: uppercase;
  position: relative;
  top: 0;
  left: 0;
  padding: 20px 40px;
  border-radius: 100px;
  display: inline-block;
  transition: all .5s;
}

.btn-white {
  background: #fff;
  color: #000;
}

.btn:hover {
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  transform: translateY(-3px);
}

.btn:active {
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}

.btn::after {
  content: "";
  text-decoration: none;
  text-transform: uppercase;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 100px;
  display: inline-block;
  z-index: -1;
  transition: all .5s;
}

.btn-white::after {
  background: #fff;
}

.btn-animation-1:hover::after {
  transform: scaleX(1.4) scaleY(1.6);
  opacity: 0;
}
</style>
